import React from "react";
import Header from "./Header";
import Footer from "./Footer";

export default function Layout({ children }) {
  return (
    <div className="min-h-screen flex flex-col bg-white">
      <Header />
      <main className="flex-1">{children}</main>
      <Footer />
    </div>
  );
}

export function Spinner() {
  return (
    <div className="flex justify-center items-center py-24" data-testid="loading-spinner">
      <div className="w-10 h-10 border-4 border-gray-200 border-t-r24-red rounded-full animate-spin" />
    </div>
  );
}
